import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / StrokePositionValue`}</p>
    <h1 {...{
      "id": "enumeration-strokepositionvalue"
    }}>{`Enumeration: StrokePositionValue`}</h1>
    <InlineAlert slots="text" variant="warning" mdxType="InlineAlert" />
*Do not depend on the literal numeric values of these constants*, as they may change. Always reference the enum identifiers in your code.
    <p>{`A stroke's `}<a parentName="p" {...{
        "href": "../interfaces/Stroke.md#position"
      }}>{`position`}</a>{` determines how the thickness of the stroke is aligned along a shape's path outline.`}</p>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "enumeration-members"
    }}>{`Enumeration Members`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "StrokePositionValue.md#center"
        }}>{`center`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "StrokePositionValue.md#inside"
        }}>{`inside`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "StrokePositionValue.md#outside"
        }}>{`outside`}</a></li>
    </ul>
    <h2 {...{
      "id": "enumeration-members-1"
    }}>{`Enumeration Members`}</h2>
    <h3 {...{
      "id": "a-idcenter-namecentera-center"
    }}><a id="center" name="center"></a>{` center`}</h3>
    <p>{`• `}<strong parentName="p">{`center`}</strong>{` = `}<inlineCode parentName="p">{`0`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idinside-nameinsidea-inside"
    }}><a id="inside" name="inside"></a>{` inside`}</h3>
    <p>{`• `}<strong parentName="p">{`inside`}</strong>{` = `}<inlineCode parentName="p">{`1`}</inlineCode></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idoutside-nameoutsidea-outside"
    }}><a id="outside" name="outside"></a>{` outside`}</h3>
    <p>{`• `}<strong parentName="p">{`outside`}</strong>{` = `}<inlineCode parentName="p">{`2`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      